import React, { useEffect, useState, useMemo } from 'react';
import moment from 'moment';
import Select from "react-select";
import { useSelector } from 'react-redux';
import Layout from "../../layout";
import services from 'API/services';
import { authenticationSeletor } from "../../store/slices/authenticationSlice";

const tabs = [
    "Property User Created",
    "Property User Modified",
    "Property Assigned",
    "Property Unassigned",
    "Password Changed",
    "Room Blocked",
    "Room Unblocked",
    "Room Cleaned",
    "Meal Plan Setting",
    "Food Item Created",
    "Food Item Modified",
    "Food Item Deleted",
    "Expense Created",
    "Expense Modified",
    "Room Tarrif",
    "Bulk Update",
    "Bulk Update - Stop Sell",
    "Stop Sell",
    "DSR Created",
    "DSR Modified"
]

const PropertyLogs = () => {

    const [propertiesList, setPropertiesList] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [logsData, setLogsData] = useState([]);
    const [activeTab, setActiveTab] = useState('Property User Created')

    const { userDetail } = useSelector(authenticationSeletor);
    const propertyUser = userDetail?.logintype == 'propertyUser';

    const fetchProperties = async () => {
        try {
            const res = await services.property.propertyListService();
            if (res.data.status === true) {
                setPropertiesList(res?.data?.data)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchProperties();
    }, [])

    const options = propertiesList?.map((item) => {
        return { value: item?.id, label: item?.name, code: item?.propertyCode }
    })

    const fetchPropertyLogs = async () => {
        try {
            const res = await services.property.getPropertyLogsService(propertyUser ? userDetail?.propertyId : selectedOption?.value);
            if (res?.data.status === true) {
                setLogsData(res?.data?.data)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchPropertyLogs()
    }, [selectedOption])

    const tabsData = useMemo(() => {
        const initialData = tabs.reduce((acc, curr) => {
            acc[curr] = [];
            return acc;
        }, {});

        const primaryData = logsData?.reduce((acc, curr) => {
            if (acc[curr.action]) {
                acc[curr.action].push(curr);
            }
            return acc;
        }, { ...initialData });
        return primaryData;

    }, [tabs, logsData]);

    const renderOperationTable = (operation) => {
        if (!operation) return null;
        let data = JSON.parse(operation);
        if (Array.isArray(data)) {
            data = data[0];
        }
        const keys = Object.keys(data);
        return (
            <table className="logs-inner-table">
                <thead>
                    <tr>
                        {keys.map((key) => (
                            <th key={key}>
                                {key.charAt(0).toUpperCase() + key.slice(1)}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        {keys.map((key) => {
                            return (
                                <td key={key}>
                                    {key == 'Date' ? moment(data[key]).format('DD-MM-YYYY') : data[key]}
                                </td>
                            )
                        })}
                    </tr>
                </tbody>
            </table>
        );
    };


    return (
        <Layout title="Property Logs">
            <div className='propertylogs'>
                {
                    !propertyUser &&
                    <div className='searcharea'>
                        <Select
                            value={selectedOption}
                            onChange={setSelectedOption}
                            options={options}
                            placeholder="Select a Property"
                        />
                    </div>
                }
                <div className='body'>
                    <ul className='tab'>
                        {
                            tabs?.map((item) => {
                                return (
                                    <li
                                        className={activeTab == item ? 'active' : ''}
                                        onClick={() => setActiveTab(item)}>
                                        {item}
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <div className='content'>
                        <h2>{activeTab}</h2>
                        <table className='table-logs'>
                            <thead>
                                <tr>
                                    <th className='one'>Date</th>
                                    <th className='two'>Property Id</th>
                                    <th className='three'>Action By</th>
                                    <th className='four'>Operation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tabsData[activeTab].length > 0 ?
                                        tabsData[activeTab]?.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td className='one'>{moment(item?.createdAt).format('DD-MM-YYYY HH:mm')}</td>
                                                    <td className='two'>
                                                        {
                                                            propertyUser ? userDetail?.propertyName : `${selectedOption?.label} - ${selectedOption?.code}`
                                                        }
                                                    </td>
                                                    <td className='three'>{item?.actionBy}</td>
                                                    <td className='four'>
                                                        {
                                                            ["Property User Created", "Property User Modified", "Property Assigned", "Property Unassigned", "Room Blocked", "Food Item Created", "Food Item Modified", "Meal Plan Setting", "Expense Created", "Expense Modified", "Room Tarrif", "Bulk Update - Stop Sell", "DSR Created", "DSR Modified"].includes(activeTab) ? renderOperationTable(item?.operation) :
                                                                ["Password Changed", "Room Unblocked", "Room Cleaned", "Food Item Deleted"].includes(activeTab) && item?.operation
                                                                ||
                                                                activeTab === "Bulk Update" && (() => {
                                                                    const data = JSON.parse(item.operation);
                                                                    return (
                                                                        <table className='logs-inner-table left'>
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Categories</th>
                                                                                    <th>From Date</th>
                                                                                    <th>To Date</th>
                                                                                    <th>3 Hrs</th>
                                                                                    <th>6 Hrs</th>
                                                                                    <th>9 Hrs</th>
                                                                                    <th>Full Day</th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>{data.categories.map((item) => `${item}, `)}</td>
                                                                                    <td>{moment(data.fromDate).format('DD-MM-YYYY')}</td>
                                                                                    <td>{moment(data.toDate).format('DD-MM-YYYY')}</td>
                                                                                    <td>{data.slotPrice.threeHrs} - {data.slotStatus.threeHrs} {data.slotTime.threeHrs}</td>
                                                                                    <td>{data.slotPrice.sixHrs} - {data.slotStatus.sixHrs} {data.slotTime.sixHrs}</td>
                                                                                    <td>{data.slotPrice.nineHrs} - {data.slotStatus.nineHrs} {data.slotTime.nineHrs}</td>
                                                                                    <td>{data.slotPrice.fullDay} - {data.slotStatus.fullDay} {data.slotTime.fullDay}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    );
                                                                })()
                                                                ||
                                                                activeTab === "Stop Sell" &&
                                                                (() => {
                                                                    const data = JSON.parse(item.operation)
                                                                    return (
                                                                        <div>
                                                                            <p>
                                                                                <span className='fw-bold'>Categories -</span> {data.categoryIds.map(cate => `${cate}, `)}
                                                                            </p>
                                                                            <table className='logs-inner-table left'>
                                                                                <thead>
                                                                                    <th>Date</th>
                                                                                    <th>Status</th>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        data.date.map((item) => {
                                                                                            return (
                                                                                                <tr className='ml-3'>
                                                                                                    <td>{item.date}</td>
                                                                                                    <td> {item.soldOut ? 'Sold-Out' : 'Available'}</td>
                                                                                                </tr>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )
                                                                })()
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }) :
                                        <tr>
                                            <td colSpan={4}>No Data Found</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {
                        (!selectedOption && !propertyUser) && <div className='no-property'>Please Select a Property</div>
                    }
                </div>
            </div>
        </Layout>
    )
}

export default PropertyLogs